import { ServerInterface } from "./ServerInterface";

function getNotificationUrl(): string {
  return ServerInterface.serverUrl + "/notifications"
}

export function urlB64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};


export function getPermission() {
  Notification.requestPermission(function (status) {
    console.log('Notification permission status:', status);
  });
};

export async function subscribeToWebpush(memberId: string) {

  try {
    getPermission();


    const { pubkey } = await fetch(`${getNotificationUrl()}/pubkey`).then((res) => res.json());
    console.log('fetched public key:', pubkey);


    const registration: ServiceWorkerRegistration | undefined = await navigator.serviceWorker.getRegistration(); //
    if (!registration) {
      console.error('no service worker registered');
      return false;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(pubkey),
    });

    console.log('created subscription:', subscription);

    if (subscription) {
      console.log('subscription:', subscription); // this is the subscription object
      if (await register(subscription, memberId)) {
        return true;
      }
    }
  } catch (ex) {
    console.error('error while subscribing to webpush', ex);
    return false;
  }
};

export async function register(subscription: PushSubscription, memberId: string): Promise<boolean> {

  try {

    const data = {
      memberId: memberId,
      subscription: subscription
    };
    console.log('register:', data);

    const res = await fetch(`${getNotificationUrl()}/register`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const txt = await res.text


    console.log('/register done', txt);
    return true;

  } catch (ex) {
    console.error('error while sending subscription to server', ex);
  }
  return false;
}


export function sendMessageViaServer(memberId: string, message: string) {

  try {
    const body = JSON.stringify({ message }, null, 2);

    const data = {
      memberId: memberId,
      title: 'Notification from server',
      body: body,
      image: 'images/checkmark.png',
    }

    fetch(`${getNotificationUrl()}/sendNotification`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('successfully send message via server to push service');

  } catch (ex) {
    console.error('Error while sending to server', ex);
  }

};


export async function displayNotificationDirectly() {


  console.log('displayNotificationDirectly');


  if (Notification.permission !== 'granted') {
    console.log('notification permission missing');
    return;
  }

  const options = {
    body: 'This notification is send without a server, directly by the browser',
    // icon: 'images/checkmark.png',
    vibrate: [100, 50, 100],
    data: {
      dateOfArrival: Date.now(),
      primaryKey: 1,
    },
    // actions: [
    //   {
    //     action: 'explore',
    //     title: 'Explore this new world',
    //     // icon: 'images/checkmark.png',
    //   },
    //   {
    //     action: 'close',
    //     title: 'Close notification',
    //     // icon: 'images/xmark.png',
    //   },
    // ],
  };


  Notification.requestPermission().then((result) => {
    if (result === "granted") {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification("Vibration Sample", {
          body: "Buzz! Buzz!",
          // icon: "../images/touch/chrome-touch-icon-192x192.png",
          // vibrate: [200, 100, 200, 100, 200, 100, 200],
          tag: "vibration-sample",
        });
        console.log('displayNotificationDirectly done');

      });
    }
  });

  // const registration = await navigator.serviceWorker.getRegistration();
  // registration?.showNotification('Notification without Push API', options);

};
